import { Grid, Tab, Tabs } from "@mui/material"
import { StaticDataAccordion } from "../../Component/Common/Components/Accordion/StaticDataAccordion";
import "./Legislation.css"
import { LegislationService } from "../../Component/Api/Legislation/LegislationService";
import { urltoFile } from "../../Component/Model/helpers";
import { ModuleType } from "../../Component/Model/Enum/BEE123Enums";
import { Link, Redirect, Route, Switch, useRouteMatch } from "react-router-dom";
import { BBBEE_Legislation } from "../../Component/Common/Constants/StaticPageConstants/BBBEELegislation";
import { BBBEE_Resources } from "../../Component/Common/Constants/StaticPageConstants/BBBEEResource";

export const BeeLegislationResourcesPage = () => {
    
    const routes = [
        "/legislation/B-BBEE/Legislation",
        "/legislation/B-BBEE/Resources",
    ]

    const routeMatch = useRouteMatch(routes);
    const currentTab = routeMatch?.path;
    const currentTabIndex = routes.findIndex(route => route === currentTab);

    const handleRedirect = () => {
        if (currentTabIndex === -1) {
            return <Redirect to={routes[0]} />;
        }
        return null;
    };

    
    return (
        <>
            <Grid container>
                <Grid item xs={12}>
                    <Tabs value={currentTab} aria-label="Tabs" centered>
                        <Tab label="B-BBEE Legislation" value={routes[0]} to={routes[0]} component={Link} />
                        <Tab label="BEE Resource Templates" value={routes[1]} to={routes[1]} component={Link}/>
                    </Tabs>
                </Grid>
                <Grid item xs={12} mt={3}>
                    <Switch>
                        {handleRedirect()}
                        <Route path={routes[0]}>
                            <BeeLegislationPage />
                        </Route>
                        <Route path={routes[1]}>
                            <BeeResourcesPage/>
                        </Route>
                    </Switch>
                </Grid>
            </Grid>
        </>
    );
};


export const BeeLegislationPage =() => {
    const followLink = async(link: string | undefined, section: number | undefined) =>{
        if(link !== undefined && section !== undefined){
            try{
                const result = await LegislationService.GetLegislationDocument(link, ModuleType.BEE_Module, section);
                const file = await urltoFile('data:text/plain;base64,' + result.data.fileContents, link, 'application/pdf')
                const url = URL.createObjectURL(file);
                const documentLink = document.createElement("a");
                documentLink.setAttribute("href", url);
                documentLink.setAttribute("download", result.data.fileDownloadName !== undefined? result.data.fileDownloadName: link);
                document.body.appendChild(documentLink);
                documentLink.click();
                document.body.removeChild(documentLink);

            }catch(error) {
                console.log(error)
            }
        }
    }
    return (
        <>
        <Grid container style={{ padding: "15px" }}>
          <Grid item xs={12} lg={12} mt={2}>
                {BBBEE_Legislation.map((leg, index) => {
                return <StaticDataAccordion key={index} {...leg} followLink={followLink}/>;
                })}
            </Grid>
        </Grid>
        </>
    )
}

export const BeeResourcesPage =() => {
    const followLink = async(link: string | undefined, section: number | undefined) =>{
        if(link !== undefined && section !== undefined){
            try{
                const result = await LegislationService.GetLegislationDocument(link, ModuleType.BEE_Module, section);
                const file = await urltoFile('data:text/plain;base64,' + result.data.fileContents, link, 'application/pdf')
                const url = URL.createObjectURL(file);
                const documentLink = document.createElement("a");
                documentLink.setAttribute("href", url);
                documentLink.setAttribute("download", result.data.fileDownloadName !== undefined? result.data.fileDownloadName: link);
                document.body.appendChild(documentLink);
                documentLink.click();
                document.body.removeChild(documentLink);

            }catch(error) {
                console.log(error)
            }
        }
    }
    return (
        <>
        <Grid container style={{ padding: "15px" }}>
          <Grid item xs={12} lg={12} mt={2}>
                {BBBEE_Resources.map((leg, index) => {
                return <StaticDataAccordion key={index} {...leg} followLink={followLink}/>;
                })}
            </Grid>
        </Grid>
       </>
    )
}

